import { LEGAL_VERSIONS } from '../constants/version';
import { LegalDocument, LegalDocumentType } from '../types/legalDocument';

export const codeOfConduct: LegalDocument = {
  id: 'code-of-conduct',

  title: 'CÓDIGO DE CONDUTA DA NEXORA',

  version: LEGAL_VERSIONS.conduct,

  source: 'docs/legal/code-of-conduct.md',

  documentType: 'conduct' as LegalDocumentType,

  lastUpdated: 'Julho de 2026',

  effectiveDate: 'Julho de 2026',

  sections: [
    {
      id: 'commitment',

      title: 'Compromisso da Nexora',

      paragraphs: [
        {
          id: 'commitment-1',
          text: 'A Nexora acredita que tecnologia, segurança e transparência caminham juntas.',
        },

        {
          id: 'commitment-2',
          text: 'Nosso objetivo é oferecer uma plataforma confiável para organização, gestão e compartilhamento responsável de conhecimento, promovendo um ambiente seguro para todos os usuários.',
        },

        {
          id: 'commitment-3',
          text: 'Este Código de Conduta estabelece os princípios que orientam a utilização da plataforma e busca garantir uma experiência profissional, organizada e respeitosa.',
        },

        {
          id: 'commitment-4',
          text: 'Ao utilizar a Nexora, você concorda em seguir as diretrizes descritas neste documento.',
        },
      ],
    },

    {
      id: 'mission',

      title: '1. Nossa Missão',

      paragraphs: [
        {
          id: 'mission-1',
          text: 'A Nexora foi criada para centralizar conhecimento, organizar processos e tornar a utilização de inteligência artificial mais segura, eficiente e escalável.',
        },

        {
          id: 'mission-2',
          text: 'Nosso compromisso é desenvolver uma plataforma preparada para crescimento contínuo, baseada em organização, confiabilidade e responsabilidade.',
        },
      ],
    },

    {
      id: 'platform-commitment',

      title: '2. Compromisso da Plataforma',

      paragraphs: [
        {
          id: 'platform-commitment-1',
          text: 'A Nexora compromete-se a:',
        },

        {
          id: 'platform-commitment-2',
          text: '* Proteger as informações armazenadas na plataforma;',
        },

        {
          id: 'platform-commitment-3',
          text: '* Buscar estabilidade e disponibilidade contínua dos serviços;',
        },

        {
          id: 'platform-commitment-4',
          text: '* Tratar os usuários com respeito, imparcialidade e transparência;',
        },

        {
          id: 'platform-commitment-5',
          text: '* Preservar a segurança e a integridade do ambiente;',
        },

        {
          id: 'platform-commitment-6',
          text: '* Evoluir continuamente seus recursos e processos.',
        },
      ],
    },

    {
      id: 'user-responsibilities',

      title: '3. Responsabilidades do Usuário',

      paragraphs: [
        {
          id: 'user-responsibilities-1',
          text: 'Ao utilizar a Nexora, o usuário compromete-se a:',
        },

        {
          id: 'user-responsibilities-2',
          text: '* Fornecer informações verdadeiras durante o cadastro;',
        },

        {
          id: 'user-responsibilities-3',
          text: '* Manter seus dados atualizados;',
        },

        {
          id: 'user-responsibilities-4',
          text: '* Utilizar a plataforma de forma ética e responsável;',
        },

        {
          id: 'user-responsibilities-5',
          text: '* Respeitar as políticas e documentos oficiais da Nexora;',
        },

        {
          id: 'user-responsibilities-6',
          text: '* Zelar pela segurança de sua conta.',
        },
      ],
    },

    {
      id: 'permitted-use',

      title: '4. Uso Permitido',

      paragraphs: [
        {
          id: 'permitted-use-1',
          text: 'A plataforma poderá ser utilizada para:',
        },

        {
          id: 'permitted-use-2',
          text: '* Organização de prompts;',
        },

        {
          id: 'permitted-use-3',
          text: '* Gestão de conhecimento;',
        },

        {
          id: 'permitted-use-4',
          text: '* Estudos e aprendizado;',
        },

        {
          id: 'permitted-use-5',
          text: '* Projetos profissionais;',
        },

        {
          id: 'permitted-use-6',
          text: '* Administração de conteúdos autorizados;',
        },

        {
          id: 'permitted-use-7',
          text: '* Utilização dos recursos disponibilizados pela Nexora.',
        },
      ],
    },

    {
      id: 'not-permitted-use',

      title: '5. Uso Não Permitido',

      paragraphs: [
        {
          id: 'not-permitted-use-1',
          text: 'Não é permitido utilizar a plataforma para:',
        },

        {
          id: 'not-permitted-use-2',
          text: '* Compartilhar credenciais de acesso;',
        },

        {
          id: 'not-permitted-use-3',
          text: '* Comercializar contas ou acessos sem autorização;',
        },

        {
          id: 'not-permitted-use-4',
          text: '* Tentar explorar vulnerabilidades da plataforma;',
        },

        {
          id: 'not-permitted-use-5',
          text: '* Burlar limitações técnicas ou administrativas;',
        },

        {
          id: 'not-permitted-use-6',
          text: '* Utilizar robôs, scripts ou automações não autorizadas;',
        },

        {
          id: 'not-permitted-use-7',
          text: '* Distribuir conteúdo protegido por direitos autorais sem autorização;',
        },

        {
          id: 'not-permitted-use-8',
          text: '* Praticar atividades ilícitas ou que violem a legislação vigente;',
        },

        {
          id: 'not-permitted-use-9',
          text: '* Utilizar a plataforma para prejudicar outros usuários ou a própria Nexora.',
        },
      ],
    },

    {
      id: 'account-security',

      title: '6. Segurança da Conta',

      paragraphs: [
        {
          id: 'account-security-1',
          text: 'Cada conta é individual e de responsabilidade exclusiva do seu titular.',
        },

        {
          id: 'account-security-2',
          text: 'O usuário deve:',
        },

        {
          id: 'account-security-3',
          text: '* Manter sua senha protegida;',
        },

        {
          id: 'account-security-4',
          text: '* Não compartilhar credenciais;',
        },

        {
          id: 'account-security-5',
          text: '* Informar imediatamente qualquer suspeita de acesso não autorizado;',
        },

        {
          id: 'account-security-6',
          text: '* Utilizar métodos de autenticação legítimos disponibilizados pela plataforma.',
        },
      ],
    },

    {
      id: 'access-sharing',

      title: '7. Compartilhamento de Acesso',

      paragraphs: [
        {
          id: 'access-sharing-1',
          text: 'O acesso à Nexora é pessoal e intransferível.',
        },

        {
          id: 'access-sharing-2',
          text: 'O compartilhamento de contas poderá resultar em medidas administrativas, incluindo:',
        },

        {
          id: 'access-sharing-3',
          text: '* Advertência;',
        },

        {
          id: 'access-sharing-4',
          text: '* Suspensão temporária;',
        },

        {
          id: 'access-sharing-5',
          text: '* Bloqueio permanente da conta.',
        },

        {
          id: 'access-sharing-6',
          text: 'A aplicação dessas medidas dependerá da análise realizada pela administração da plataforma.',
        },
      ],
    },

    {
      id: 'platform-content',

      title: '8. Conteúdo da Plataforma',

      paragraphs: [
        {
          id: 'platform-content-1',
          text: 'Todo conteúdo disponibilizado pela Nexora é protegido pelas legislações aplicáveis de propriedade intelectual.',
        },

        {
          id: 'platform-content-2',
          text: 'É proibido:',
        },

        {
          id: 'platform-content-3',
          text: '* Copiar integralmente conteúdos exclusivos da plataforma;',
        },

        {
          id: 'platform-content-4',
          text: '* Redistribuir materiais protegidos sem autorização;',
        },

        {
          id: 'platform-content-5',
          text: '* Comercializar conteúdos exclusivos da Nexora sem consentimento formal.',
        },

        {
          id: 'platform-content-6',
          text: 'Quando aplicável, os conteúdos criados pelo próprio usuário permanecem de sua responsabilidade.',
        },
      ],
    },

    {
      id: 'administrative-measures',

      title: '9. Medidas Administrativas',

      paragraphs: [
        {
          id: 'administrative-measures-1',
          text: 'Para preservar a segurança da plataforma, a Nexora poderá adotar medidas administrativas quando identificar comportamentos incompatíveis com este Código.',
        },

        {
          id: 'administrative-measures-2',
          text: 'Essas medidas poderão incluir:',
        },

        {
          id: 'administrative-measures-3',
          text: '* Solicitação de informações adicionais;',
        },

        {
          id: 'administrative-measures-4',
          text: '* Restrição temporária de acesso;',
        },

        {
          id: 'administrative-measures-5',
          text: '* Suspensão da conta;',
        },

        {
          id: 'administrative-measures-6',
          text: '* Bloqueio definitivo da conta;',
        },

        {
          id: 'administrative-measures-7',
          text: '* Encerramento da relação contratual, quando necessário.',
        },

        {
          id: 'administrative-measures-8',
          text: 'Sempre que possível, as decisões serão fundamentadas em critérios técnicos e administrativos.',
        },
      ],
    },

    {
      id: 'code-updates',

      title: '10. Atualizações deste Código',

      paragraphs: [
        {
          id: 'code-updates-1',
          text: 'Este Código poderá ser atualizado para acompanhar a evolução da plataforma, mudanças legais ou aprimoramentos operacionais.',
        },

        {
          id: 'code-updates-2',
          text: 'Sempre que houver alterações relevantes, uma nova versão será publicada.',
        },

        {
          id: 'code-updates-3',
          text: 'Quando necessário, os usuários poderão ser convidados a aceitar novamente a versão vigente antes de continuar utilizando determinados recursos da plataforma.',
        },
      ],
    },

    {
      id: 'contact',

      title: '11. Contato',

      paragraphs: [
        {
          id: 'contact-1',
          text: 'Em caso de dúvidas relacionadas a este Código de Conduta, o usuário poderá entrar em contato com os canais oficiais de atendimento disponibilizados pela Nexora.',
        },
      ],
    },

    {
      id: 'final-considerations',

      title: 'Considerações Finais',

      paragraphs: [
        {
          id: 'final-considerations-1',
          text: 'A Nexora acredita que um ambiente seguro depende da colaboração entre plataforma e usuários.',
        },

        {
          id: 'final-considerations-2',
          text: 'Ao utilizar nossos serviços, você contribui para manter uma comunidade organizada, respeitosa e preparada para crescer de forma sustentável.',
        },

        {
          id: 'final-considerations-3',
          text: 'Agradecemos por fazer parte da Nexora.',
        },
      ],
    },
  ],
};
